import React from 'react'
import UnderConstruction from '../components/UnderConstruction'

const Revistas = () => {
  return <UnderConstruction pageName="Revistas" />
}

export default Revistas